import { useTranslation } from "react-i18next";
import { Payments as PaymentsFeature } from "@/partner/features/payments";
import { Meta } from "@/shared/components";

export function PaymentsPage() {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("payments.pageTitle")} pageType="Partner" />
      <PaymentsFeature />
    </>
  );
}
